import React from 'react'
import { Link } from '@mui/material'
import { Link as RouterLink } from 'react-router-dom'
import { useSession } from '@emerald-works/react-auth'
import { useLocationScroll } from '../../hooks'
import { WHATS_NEW_COPY, WHATS_NEW_ENABLED, WHATS_NEW_ENTRY_SOURCE, whatsNewPath } from './constants'

/**
 * Whether a footer shows the link: the feature is on and someone is signed in.
 * The page is private, so a link that only leads to the login form is noise on
 * the public article pages a logged-out visitor sees. The footers gate their
 * grid cell on this, not the link itself, so no empty cell is left behind.
 */
export const useShowWhatsNewLink = () => {
  const { isAuthenticated } = useSession()
  return WHATS_NEW_ENABLED && Boolean(isAuthenticated)
}

/**
 * The persistent, low-key entry point: a text link for the page footers
 * (consumer and enterprise), shown under `useShowWhatsNewLink`.
 */
export const WhatsNewLink = props => {
  return (
    <Link
      component={RouterLink}
      to={whatsNewPath(WHATS_NEW_ENTRY_SOURCE.FOOTER)}
      state={{ [useLocationScroll.SCROLLTOP]: true }}
      underline='none'
      data-test='whats-new-link'
      {...props}
    >
      {WHATS_NEW_COPY.title}
    </Link>
  )
}

export default WhatsNewLink
